module.exports = __webpack_public_path__ + "png/vip.png?a1c2ef3a384d40f8184d35c9f31eb179";